import { render, staticRenderFns } from "./EmployerDescDrawer.vue?vue&type=template&id=4aae1e02&scoped=true"
import script from "./EmployerDescDrawer.vue?vue&type=script&lang=js"
export * from "./EmployerDescDrawer.vue?vue&type=script&lang=js"
import style0 from "./EmployerDescDrawer.vue?vue&type=style&index=0&id=4aae1e02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aae1e02",
  null
  
)

export default component.exports